@use '../../scss/utility/functions' as utility;
@use './round-button-vars.scss';
@use './round-button-common.scss';
@use './timer-animation/timer-animation';

:host {
  @include round-button-vars.wb-round-button-vars;
  @include round-button-vars.wb-round-button-translucent-vars;
  display: inline-block;
  position: relative;

  .button {
    @include round-button-common.wb-round-button;

    &:hover:not([aria-disabled='true']):not([disabled]) {
      @include round-button-vars.wb-round-button-translucent-hover-vars;
    }
    &:focus {
      @include round-button-vars.wb-round-button-translucent-focus-vars;
    }
    &:active:not([aria-disabled='true']):not([disabled]) {
      @include round-button-vars.wb-round-button-translucent-active-vars;
    }
  }
}

::slotted(.wb-icon) {
  @include round-button-common.wb-round-button-icon;
}

:host([disabled]) {
  pointer-events: none;

  .button {
    @include round-button-common.wb-round-button-disabled;
  }
}

:host([disabled][focusable-when-disabled]) .button {
  pointer-events: all;
}

:host([size='s']) {
  @include round-button-vars.wb-round-button-size-s-vars;
}

:host([size='m']) {
  @include round-button-vars.wb-round-button-size-m-vars;
}

:host([size='l']) {
  @include round-button-vars.wb-round-button-size-l-vars;
}

:host([size='new-s']) {
  @include round-button-vars.wb-round-button-size-new-s-vars;
}

:host([size='new-m']) {
  @include round-button-vars.wb-round-button-size-new-m-vars;
}

:host([size='new-l']) {
  @include round-button-vars.wb-round-button-size-new-l-vars;
}

:host([size='new-xl']) {
  @include round-button-vars.wb-round-button-size-new-xl-vars;
}

:host([elevation='xs']) {
  @include round-button-vars.wb-round-button-elevation-xs-vars;

  .button {
    &:hover:not([aria-disabled='true']):not([disabled]) {
      @include round-button-vars.wb-round-button-elevation-xs-hover-vars;
    }
    &:focus {
      @include round-button-vars.wb-round-button-elevation-xs-focus-vars;
    }
    &:active:not([aria-disabled='true']):not([disabled]) {
      @include round-button-vars.wb-round-button-elevation-xs-active-vars;
    }
  }
}

:host([elevation='s']) {
  @include round-button-vars.wb-round-button-elevation-s-vars;

  .button {
    &:hover:not([aria-disabled='true']):not([disabled]) {
      @include round-button-vars.wb-round-button-elevation-s-hover-vars;
    }
    &:focus {
      @include round-button-vars.wb-round-button-elevation-s-focus-vars;
    }
    &:active:not([aria-disabled='true']):not([disabled]) {
      @include round-button-vars.wb-round-button-elevation-s-active-vars;
    }
  }
}

:host([elevation='m']) {
  @include round-button-vars.wb-round-button-elevation-m-vars;

  .button {
    &:hover:not([aria-disabled='true']):not([disabled]) {
      @include round-button-vars.wb-round-button-elevation-m-hover-vars;
    }
    &:focus {
      @include round-button-vars.wb-round-button-elevation-m-focus-vars;
    }
    &:active:not([aria-disabled='true']):not([disabled]) {
      @include round-button-vars.wb-round-button-elevation-m-active-vars;
    }
  }
}

:host([elevation='l']) {
  @include round-button-vars.wb-round-button-elevation-l-vars;

  .button {
    &:hover:not([aria-disabled='true']):not([disabled]) {
      @include round-button-vars.wb-round-button-elevation-l-hover-vars;
    }
    &:focus {
      @include round-button-vars.wb-round-button-elevation-l-focus-vars;
    }
    &:active:not([aria-disabled='true']):not([disabled]) {
      @include round-button-vars.wb-round-button-elevation-l-active-vars;
    }
  }
}
